import { BENEFITS_KEY_OVERRIDES } from 'helpers/benefits-key-overrides'
import { convertKeysToPascalCase } from 'helpers/convertKeysToPascalCase'

/**
 * Remap EPS POST /core/enrollments/:id/cart/recalculate response to legacy
 * PascalCase cart shape for Redux selectors / ViewCart UI.
 *
 * Uses shared convertKeysToPascalCase + BENEFITS_KEY_OVERRIDES so acronym keys
 * (sbcUrl → SBCUrl, hsaMath → HSAMath) round-trip correctly.
 */
export function remapCartRecalculateResponse(raw) {
  const remapped = convertKeysToPascalCase(raw ?? {}, BENEFITS_KEY_OVERRIDES)
  return {
    ...remapped,
    Cart: remapped.Cart ?? [],
  }
}
